import { apiClient } from "../../../lib/axios";
import type {
  LoginRequest,
  LoginResponse,
  ChangePasswordRequest,
  ChangePasswordResponse,
  LogoutResponse,
  IsAuthenticatedResponse,
  CurrentUserResponse,
  ForgotPasswordRequest,
  ForgotPasswordResponse,
  ConfirmForgotPasswordRequest,
  ConfirmForgotPasswordResponse,
} from "./types";

export const authApi = {
  login: async (data: LoginRequest): Promise<LoginResponse> => {
    const response = await apiClient.post("/auth/", data);
    return response.data;
  },

  changePassword: async (
    data: ChangePasswordRequest
  ): Promise<ChangePasswordResponse> => {
    const response = await apiClient.post(
      "/auth/initial-change-password",
      data
    );
    return response.data;
  },

  logout: async (): Promise<LogoutResponse> => {
    const response = await apiClient.post("/auth/logout");
    return response.data;
  },

  getMe: async () => {
    try {
      const [authResponse, userResponse] = await Promise.all([
        apiClient.get<IsAuthenticatedResponse>("/auth/is-authenticated"),
        apiClient.get<CurrentUserResponse>("/auth/current-user"),
      ]);

      const isAuthenticated =
        authResponse.data.message === "User is authenticated";
      const user = userResponse.data.data;

      return {
        authenticated: isAuthenticated,
        user: isAuthenticated ? user : null,
        needs_new_password: false,
      };
    } catch {
      return {
        authenticated: false,
        user: null,
        needs_new_password: false,
      };
    }
  },

  isAuthenticated: async (): Promise<IsAuthenticatedResponse> => {
    const response = await apiClient.get("/auth/is-authenticated");
    return response.data;
  },

  getCurrentUser: async (): Promise<CurrentUserResponse> => {
    const response = await apiClient.get("/auth/current-user");
    return response.data;
  },

  forgotPassword: async (
    data: ForgotPasswordRequest
  ): Promise<ForgotPasswordResponse> => {
    const response = await apiClient.post("/auth/forgot-password", data);
    return response.data;
  },

  confirmForgotPassword: async (
    data: ConfirmForgotPasswordRequest
  ): Promise<ConfirmForgotPasswordResponse> => {
    const response = await apiClient.post(
      "/auth/confirm-forgot-password",
      data
    );
    return response.data;
  },
};

export const getMe = authApi.getMe;